import React from 'react';
import { ProgressDashboard } from '../components/progress/progressDashboard';
import {Header} from '../components/global/header';
import {Footer} from '../components/global/footer';

const ProgressDashboardPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
        <ProgressDashboard />
      <Footer />
    </div>
  );
};

export default ProgressDashboardPage;
